import _ from "lodash";
import gen from "random-seed";

class ZMath {

  /**
   * Check if the data is between a range
   * @param {Number} value 
   * @param {Number} a 
   * @param {Number} b 
   * @param {"[)" | "[]" | "(]" | "()"} inclusivity 
   */
   static IsBetween(value, a, b, inclusivity = "[)"){
    switch(inclusivity){
      case "[)": return value >= a && value < b;
      case "[]": return value >= a && value <= b;
      case "(]": return value > a && value <= b;
      case "()": default:
        return value > a && value < b;
    }
  }

  /**
   * 
   * @param {Number} value 
   * @param {Number} spaces 
   */
  static Round(value, spaces = 2){
    return Math.round(value * (1 << spaces)) / (1 << spaces);
  }

  /**
   * 
   * @param {Number} value 
   * @param {Number} min 
   * @param {Number} max 
   * @returns 
   */
  static Cap(value, min, max){
    return Math.max(min, Math.min(value, max));
  }

  /**
   * 
   * @param {Number} min 
   * @param {Number} max 
   * @returns 
   */
  static RandomInt(min, max){
    return Math.round(min + Math.random() * max);
  }

  /**
   * 
   * @param {Number} min 
   * @param {Number} max 
   * @returns 
   */
  static Random(min, max){
    return min + Math.random() * (max - min);
  }

  /**
   * 
   * @param {Number[]} min 
   * @param {Number[]} max 
   * @returns 
   */
  static CosineSimilarity(arrayA, arrayB){
    var dotproduct=0;
    var mA=0;
    var mB=0;
    for(let i = 0; i < arrayA.length; i++){
        dotproduct += (arrayA[i] * arrayB[i]);
        mA += (arrayA[i]*arrayA[i]);
        mB += (arrayB[i]*arrayB[i]);
    }
    mA = Math.sqrt(mA);
    mB = Math.sqrt(mB);
    var similarity = (dotproduct)/((mA)*(mB));
    return similarity;
  }

  /**
   * 
   * @param {Number} bytes 
   * @param {Number} boundary 
   * @param {Number} fixed
   * @returns 
   */
  static FileSizeUnit(bytes, boundary = 0.7, fixed = 2, base = 1000){
    let temp = Number(bytes);
    if(_.isNaN(temp)) return [0, "Bytes"];

    let prev;
    let units = ["Bytes", "KB", "MB", "GB", "TB"];
    for(let i = 0; i<units.length; i++){
      prev = temp;
      temp = prev / base;
      if(temp < boundary) {
        prev = prev.toFixed(fixed);
        prev = this.NumberWithCommas(prev);
        return [prev, units[i]];
      }
    }
    temp = temp.toFixed(fixed);
    temp = this.NumberWithCommas(temp);
    return [temp, units[units.length - 1]];
  }

  /**
   * 
   * @param {*} bytes 
   * @param {"Bytes" | "KB" | "MB" | "GB" | "TB"} unit
   * @returns 
   */
  static FileSizeInUnit(bytes, unit = "MB", base = 1000){
    let temp = Number(bytes);
    if(_.isNaN(temp)) return 0;

    let units = ["Bytes", "KB", "MB", "GB", "TB"];
    let index = units.indexOf(unit);
    if(index === -1) return 0;

    for(let i = 0; i<index; i++){
      temp /= base;
    }
    return temp;
  }

  /**
   * 
   * @param {String} seed 
   * @param {Number} min 
   * @param {Number} max 
   * @returns 
   */
  static SeedRandomInt(seed, min, max){
    return Math.round(this.SeedRandom(seed, min, max));
  }

  /**
   * 
   * @param {String} seed 
   * @param {Number} min 
   * @param {Number} max 
   * @returns 
   */
  static SeedRandom(seed, min, max){
    let rand = gen.create(seed);
    return min + rand(max);
  }

  /**
   * 
   * @param {Number} deg 
   * @returns 
   */
  static Deg2Rad(deg)
  {
    return deg * (Math.PI/180);
  }
  
  /**
   * 
   * @param {Number} rad 
   * @returns 
   */
  static Rad2Deg(rad){
    return rad * (180/Math.PI);
  }

  /**
   * 
   * @param {Number} num 
   * @returns 
   */
  static NumberWithCommas(num) {
    return num?.toString?.().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? "";
  }

}

export default ZMath;